// src/components/profile-input/StepNavigation.jsx
import React from "react";
import { Box, Button } from "@mui/material";
import { WhatsApp as WhatsAppIcon } from "@mui/icons-material";

const StepNavigation = ({ 
  activeStep, 
  steps, 
  handleBack, 
  handleNext, 
  shareOnWhatsApp,
  WHATSAPP_NUMBER 
}) => {
  return (
    <Box sx={{ display: 'flex', justifyContent: 'space-between', pt: 2 }}>
      {/* Back Button */}
      <Button
        disabled={activeStep === 0}
        onClick={handleBack}
        sx={{ mr: 1 }}
      >
        Back
      </Button>

      {/* Next / WhatsApp Button */}
      <Box>
        {activeStep < steps.length - 1 ? (
          <Button
            variant="contained"
            onClick={handleNext}
          >
            Next
          </Button>
        ) : (
          <Button
            variant="contained"
            color="success"
            startIcon={<WhatsAppIcon />}
            onClick={shareOnWhatsApp}
            size="large"
            sx={{ 
              backgroundColor: '#25D366', 
              '&:hover': { backgroundColor: '#128C7E' } 
            }}
          >
            Send to +{WHATSAPP_NUMBER}
          </Button>
        )}
      </Box>
    </Box>
  );
};

export default StepNavigation;